import { render } from "./Fornitori.vue?vue&type=template&id=cdb8b824"
import script from "./Fornitori.vue?vue&type=script&lang=js"
export * from "./Fornitori.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__